import { BaseDto } from '../../core';
import { REFUND_METHOD, REFUND_TYPE } from '../../shared';

export class BuyerWithdrawDto extends BaseDto<BuyerWithdrawDto> {
  refundMethodAccount: string;
  refundMethod: REFUND_METHOD;
  bankNationality: string;
  refundBankName: string;
  refundBankAddress: string;
  refundSwiftCode: string;
  refundAccountNumber: string;
  refundAccountHolder: string;
  refundType: REFUND_TYPE;
  password: string;
}
